// Web stub for react-native-purchases (RevenueCat)
// This module is native-only; on web subscription checks go through Supabase only.

const noop = () => {};
const noopAsync = () => Promise.resolve(undefined);

const Purchases = {
  configure: noopAsync,
  logIn: noopAsync,
  logOut: noopAsync,
  getCustomerInfo: () => Promise.resolve({ entitlements: { active: {} } }),
  getOfferings: () => Promise.resolve(null),
  purchasePackage: () => Promise.resolve({ customerInfo: { entitlements: { active: {} } } }),
  restorePurchases: () => Promise.resolve({ entitlements: { active: {} } }),
};

module.exports = {
  default: Purchases,
  ...Purchases,
};
